module.exports = __webpack_public_path__ + "static/media/11_Kiaan_T@3x.3253dfe4.jpg";